import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginTranslatePipe} from './pipes/login.translate.pipe';
import {ActionTranslatePipe} from './pipes/action.translate.pipe';
import {LabelTranslatePipe} from './pipes/label.translate.pipe';
import {MessageTranslatePipe} from './pipes/message.translate.pipe';
import {TitleTranslatePipe} from './pipes/title.translate.pipe';
import {FormsModule} from '@angular/forms';
import {DateTimeModule} from '../datetime/datetime.module';
import {OrgStructureDescriptionTranslatePipe} from './pipes/org.structure.description.translate.pipe';
//import {OrgStructureErrorMessageTranslatePipe} from './pipes/org.structure.error.message.translate.pipe';
import {OrgStructureLocationDescriptionTranslatePipe} from './pipes/org.structure.location.description.translate.pipe';
import {ProcedureCodeDescriptionTranslatePipe} from './pipes/procedure.code.description.translate.pipe';
import {SpsCodeDescriptionTranslatePipe} from './pipes/sps.code.description.translate.pipe';
import {ClickOutModule} from '../directives/click.out/click.out.module';

@NgModule({
  declarations: [
    ActionTranslatePipe,
    LabelTranslatePipe,
    LoginTranslatePipe,
    MessageTranslatePipe,
    TitleTranslatePipe,
    OrgStructureDescriptionTranslatePipe,
    //OrgStructureErrorMessageTranslatePipe,
    OrgStructureLocationDescriptionTranslatePipe,
    ProcedureCodeDescriptionTranslatePipe,
    SpsCodeDescriptionTranslatePipe
  ],
  exports: [
    ActionTranslatePipe,
    LabelTranslatePipe,
    LoginTranslatePipe,
    MessageTranslatePipe,
    TitleTranslatePipe,
    OrgStructureDescriptionTranslatePipe,
    //OrgStructureErrorMessageTranslatePipe,
    OrgStructureLocationDescriptionTranslatePipe,
    ProcedureCodeDescriptionTranslatePipe,
    SpsCodeDescriptionTranslatePipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    DateTimeModule,
    ClickOutModule
  ]
})
export class TranslateModule { }
